import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			transform: "translate(0.867188 0.897217)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7031 9.7478H21.0338V23.3543H12.7031V9.7478Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5617 16.5522C13.5607 15.242 13.8577 13.9488 14.4302 12.7703C15.0028 11.5919 15.8359 10.5591 16.8666 9.75017C15.5901 8.74698 14.0571 8.12316 12.4428 7.95C10.8286 7.77683 9.19816 8.06132 7.73794 8.77094C6.27771 9.48056 5.04659 10.5867 4.18527 11.9629C3.32395 13.3391 2.86719 14.9299 2.86719 16.5534C2.86719 18.1769 3.32395 19.7677 4.18527 21.1439C5.04659 22.5201 6.27771 23.6262 7.73794 24.3359C9.19816 25.0455 10.8286 25.33 12.4428 25.1568C14.0571 24.9836 15.5901 24.3598 16.8666 23.3566C15.8356 22.5474 15.0023 21.5143 14.4297 20.3354C13.8571 19.1565 13.5603 17.8628 13.5617 16.5522V16.5522Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0408 21.9145V21.6357H30.161V21.578H29.875V21.6357H29.988V21.9145L30.0408 21.9145ZM30.596 21.9145V21.578H30.5095L30.4086 21.8184L30.3076 21.578H30.2211V21.9145H30.2836V21.6597L30.3773 21.8785H30.4422L30.536 21.6597V21.9145H30.596Z",
			fill: "#F79E1B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8669 16.5522C30.8669 18.1759 30.41 19.7668 29.5485 21.143C28.687 22.5193 27.4557 23.6254 25.9953 24.3349C24.5349 25.0444 22.9043 25.3287 21.29 25.1553C19.6756 24.9819 18.1426 24.3577 16.8662 23.3542C17.8964 22.5446 18.7293 21.5115 19.302 20.333C19.8748 19.1545 20.1723 17.8613 20.1723 16.551C20.1723 15.2407 19.8748 13.9475 19.302 12.769C18.7293 11.5905 17.8964 10.5574 16.8662 9.74778C18.1426 8.74427 19.6756 8.12013 21.29 7.94672C22.9043 7.7733 24.5349 8.0576 25.9953 8.76713C27.4557 9.47665 28.6871 10.5828 29.5485 11.959C30.41 13.3353 30.8669 14.9262 30.8669 16.5498V16.5522Z",
			fill: "#F79E1B"
		})
	]
});
export default SvgMastercard;
